const LabelTextTemplate = ({
  title,
  subTitle = '',
  height = 80,
  classMain = 'common-lable-info',
  classTitle = 'title',
  classSubTitle = 'sub-title',
  borderBottom = false,
  fontSizeTitle = 15,
  titleColor = '#101828',
  fontSizeSub = 14,
}) => {
  return (
    <div
      className={classMain}
      style={{
        minHeight: height,
        borderBottom: borderBottom ? '1px solid rgb(224, 227, 231)' : 'unset',
      }}
    >
      <div>
        <div
          className={classTitle}
          style={{ fontSize: fontSizeTitle, color: titleColor }}
        >
          {title}
        </div>
        <div className={classSubTitle} style={{ fontSize: fontSizeSub }}>
          {subTitle}
        </div>
      </div>
    </div>
  );
};

export default LabelTextTemplate;
